import { useTheme } from '@mui/system'
import { useMediaQuery } from '@mui/material'
import { cx } from '@emotion/css'
import { CustomerCareHeader, CustomerCareMenu } from '../../organisms/customer-care'
import ConditionalWrapper from '../../particles/conditional-wrapper'
import { Container, CustomerCareSidebar, LeftColumn, Root, SubContainer } from './customer-care-nested-layout.styled'

const CustomerCareLayout = ({ children, layout, showSidebar }) => {
	const { cssClass, breadcrumbsName = '', activeMenuItem = '' } = layout || {}
	const theme = useTheme()
	const mdXlBetween = useMediaQuery(theme.breakpoints.between('md', 'xl'))

	return (
		<Root className={cx('customer-care-nested-layout', { 'no-sidebar': !showSidebar }, cssClass)}>
			<CustomerCareHeader breadcrumbsName={breadcrumbsName} />
			<Container className="customer-care-nested-layout-container">
				<ConditionalWrapper condition={mdXlBetween} wrapper={(children) => <LeftColumn>{children}</LeftColumn>}>
					<CustomerCareMenu activeMenuItem={activeMenuItem} />
					{mdXlBetween && showSidebar && <CustomerCareSidebar />}
				</ConditionalWrapper>
				<SubContainer className={cx('customer-care-nested-layout-subcontainer')}>{children}</SubContainer>
				{!mdXlBetween && showSidebar && <CustomerCareSidebar />}
			</Container>
		</Root>
	)
}

export default CustomerCareLayout
